'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { type ConsultationFormData, createInitialConsultationForm } from '@/app/cc/_types/consultationForm';
import type { KindType } from '@/app/cc/_types/types';
export function useConsultationFormState(kind) {
  const $ = _c(10);
  let t0;
  if ($[0] !== kind) {
    t0 = () => createInitialConsultationForm(kind);
    $[0] = kind;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [form, setForm] = useState(t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = value => {
      setForm(prev => ({
        ...prev,
        counselingTime: value
      }));
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const setCounselingTime = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = value_0 => {
      setForm(prev_0 => ({
        ...prev_0,
        name: value_0
      }));
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const setName = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = value_1 => {
      setForm(prev_1 => ({
        ...prev_1,
        phone: value_1
      }));
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const setPhone = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = value_2 => {
      setForm(prev_2 => ({
        ...prev_2,
        contractFlag: value_2
      }));
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const setContractFlag = t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = value_3 => {
      setForm(prev_3 => ({
        ...prev_3,
        privacyUseFlag: value_3
      }));
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const setPrivacyUseFlag = t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = value_4 => {
      setForm(prev_4 => ({
        ...prev_4,
        privacyProvideFlag: value_4
      }));
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const setPrivacyProvideFlag = t6;
  let t7;
  if ($[8] !== form) {
    t7 = {
      form,
      setCounselingTime,
      setName,
      setPhone,
      setContractFlag,
      setPrivacyUseFlag,
      setPrivacyProvideFlag
    };
    $[8] = form;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
}